import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root'
})
export class SettingService {

  constructor(private _HttpClient:HttpClient) { }
  UploadFile(data:any):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Setting/UploadFile`,data);
  }
  GetFile():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Setting/GetFile`);
  }
}
